import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';

export default styled.span`
  color: ${colors.alert};
  padding: 0.25rem 0;
`;
